import React from "react";

const RowRaces = ({ background, item, type, onClick, badge, msg, title }) => {
  return (
    <tr style={{ backgroundColor: background }} onClick={onClick}>
      <td className="col-md-3">{item.ProcessDateTime}</td>
      <td className="col-md-2">
        <span className="badge" style={{ backgroundColor: badge }}>
          {type}
        </span>
      </td>
      <td className="col-md-7 text-start">
        <b className="font-weight-bold">{title}</b>
        <br />
        <span>{msg}</span>
      </td>
    </tr>
  );
};

export default RowRaces;
